import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import { useState } from 'react';
import Container from '/@/components/container';
import MyRecommendationsHeader, { MyRecommendationsExpertoHeader } from '/@/components/my-recommendations/header';
import MyRecommendationsMobile from '/@/components/my-recommendations/mobile';
import MyRecommendationsTable, { MyRecommendationsExpertoTable } from '/@/components/my-recommendations/table';
import SnackbarAlert from '/@/components/snackbar-alert';
import settings from '/@/core/settings';
import useMyRecommendations from '/@/hooks/my-recommendations/useFilterMyRecommendations';
import { _ } from '/@/locale';
import { isMobile } from '/@/utils';
import useWindowSize from '/@/utils/hooks/window-size';

const MyRecommendations = () => {
    const [showFilter, setShowFilter] = useState(true);
    const [selected, setSelected] = useState([]);
    const [openSnack, setOpenSnack] = useState(false);
    const windowSize = useWindowSize();
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const isDesktop = !isMobile() && windowSize.width >= 800;
    const {
        recos,
        filterRecos,
        setFilterRecos,
        loading,
        deleteRecommendations,
        count,
        page,
        setPage,
        filterOptions,
        setSortBy,
        sortBy,
        shareRecommendations,
    } = useMyRecommendations({ rowsPerPage });

    if (isDesktop) {
        if (settings.app.theme === 'expertobayer') {
            return (
                <>
                    <MyRecommendationsExpertoHeader
                        setSelected={setSelected}
                        selected={selected}
                        setOpenSnack={setOpenSnack}
                        deleteRecommendations={deleteRecommendations}
                    />

                    <MyRecommendationsExpertoTable
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        loading={loading}
                        selected={selected}
                        rows={recos}
                        setShowFilter={setShowFilter}
                        setSelected={setSelected}
                        count={count}
                        page={page}
                        setPage={setPage}
                        setSortBy={setSortBy}
                        sortBy={sortBy}
                        filterRecos={filterRecos}
                        setFilterRecos={setFilterRecos}
                        showFilter={showFilter}
                        setOpenSnack={setOpenSnack}
                        filterOptions={filterOptions}
                        shareRecommendations={shareRecommendations}
                    />

                    <SnackbarAlert openSnack={openSnack} setOpenSnack={setOpenSnack} severity='blue'>
                        {_('Recomendación/es eliminada/s correctamente')}
                    </SnackbarAlert>
                </>
            );
        }
        return (
            <Container>
                <MyRecommendationsHeader
                    recommendations={recos}
                    filterRecos={filterRecos}
                    setFilterRecos={setFilterRecos}
                    showFilter={showFilter}
                    setShowFilter={setShowFilter}
                    setSelected={setSelected}
                    selected={selected}
                    setOpenSnack={setOpenSnack}
                    deleteRecommendations={deleteRecommendations}
                    filterOptions={filterOptions}
                />
                {loading ? (
                    <Grid container flexDirection='column' spacing={2} sx={{ my: 2 }}>
                        {Array.from(new Array(4)).map((_, index) => (
                            <Grid item key={index}>
                                <Skeleton variant='rectangular' width='100%' height={50} />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <MyRecommendationsTable
                        selected={selected}
                        rows={recos}
                        setShowFilter={setShowFilter}
                        setSelected={setSelected}
                        count={count}
                        page={page}
                        setPage={setPage}
                        setSortBy={setSortBy}
                        sortBy={sortBy}
                    />
                )}
                <SnackbarAlert openSnack={openSnack} setOpenSnack={setOpenSnack} severity='blue'>
                    {_('Recomendación/es eliminada/s correctamente')}
                </SnackbarAlert>
            </Container>
        );
    }
    return (
        <MyRecommendationsMobile
            recommendations={recos}
            rows={recos}
            filterRecos={filterRecos}
            setFilterRecos={setFilterRecos}
            count={count}
            page={page}
            setPage={setPage}
            loading={loading}
        />
    );
};

export default MyRecommendations;
